/* lwa-affiliate.js — Creator Guild attribution, site-wide.
   - reads ?ref=CODE → validates against the wall-kit creator registry
     → stores a 60-day ref window in localStorage (matches Affiliate Terms)
   - fire-and-forget click ping to /api/track
   - writes the code onto the cart as an attribute on every page view while
     the ref window is live (cart attributes ride through checkout onto the
     order's note_attributes — that is the attribution record) */
(function(){
  var KIT = window.LWA_KIT || 'https://lwa-wall-kit.fly.dev';
  var DAYS = 60, LS = 'lwa-ref';
  function readRef(){
    try {
      var r = JSON.parse(localStorage.getItem(LS) || 'null');
      if (r && r.code && r.exp > Date.now()) return r.code;
    } catch(e){}
    return null;
  }
  function storeRef(code){
    try { localStorage.setItem(LS, JSON.stringify({code: code, exp: Date.now() + DAYS*864e5})); } catch(e){}
  }
  function syncCart(code){
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({attributes: {affiliate: code}})
    }).catch(function(){});
  }
  var code = (new URLSearchParams(location.search).get('ref') || '')
             .toLowerCase().replace(/[^a-z0-9-]/g, '').slice(0, 32);
  if (code) {
    fetch(KIT + '/creators/' + code)
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(d){
        if (!d || !d.ok) return;             // unknown code — ignore
        storeRef(code);
        syncCart(code);
        fetch(KIT + '/api/track?code=' + encodeURIComponent(code)
              + '&to=' + encodeURIComponent(location.pathname)).catch(function(){});
      })
      .catch(function(){});
  } else {
    var existing = readRef();
    if (existing) syncCart(existing);        // keep the attribute fresh during the window
  }
  window.LWA_REF = readRef();
})();
